import { CircleX } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ErrorIcon = createLucideIcon(CircleX);
